import type { UseQueryResult } from '@tanstack/react-query';
import { useBffGet } from '../bff';
import { BffQueryKey } from '../model/BffQueryKey';
import type { BFFHttpError } from '../model/BFFHttpError';
import type { ProductRelatedCategories } from './model/ProductRelatedCategories';

export const useRelatedCategories = (
    productIdOrType: string,
    requestOptions?: { query?: string },
): UseQueryResult<ProductRelatedCategories, BFFHttpError> =>
    useBffGet<ProductRelatedCategories>(
        productIdOrType
            ? `/products/${productIdOrType}/related-categories?${requestOptions?.query ? `query=${requestOptions.query}` : ''}`
            : null,
        [],
        [BffQueryKey.RELATED_PAGES, productIdOrType ?? ''],
        { enabled: !!productIdOrType },
    );
